import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Award, Users, Briefcase, TrendingUp } from 'lucide-react';
import { HISTORY_ROUTE } from '../../routes/web/rootRoutes';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

function HistoryAboutSection() {
    useEffect(() => {
        AOS.init({
            duration: 600,
            once: true,
            easing: 'ease-out-cubic'
        });
    }, []);

    const stats = [
        {
            icon: <Users className="w-6 h-6 md:w-8 md:h-8" />,
            number: '500+',
            label: 'Active Members',
            color: 'from-blue-500 to-cyan-500'
        },
        {
            icon: <Award className="w-6 h-6 md:w-8 md:h-8" />,
            number: '30+',
            label: 'Years of Excellence',
            color: 'from-red-500 to-orange-500'
        },
        {
            icon: <Briefcase className="w-6 h-6 md:w-8 md:h-8" />,
            number: '1000+',
            label: 'Projects Completed',
            color: 'from-purple-500 to-pink-500'
        },
        {
            icon: <TrendingUp className="w-6 h-6 md:w-8 md:h-8" />,
            number: '50+',
            label: 'Industry Awards',
            color: 'from-green-500 to-emerald-500'
        }
    ];
const milestones = useSelector((state) => state?.globalState?.siteSetting?.milestones_history);


  

    return (
        <section className="bg-white py-12 md:py-20">
            <div className="max-w-7xl mx-auto px-4">
                
                {/* About Section */}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 mb-16 md:mb-20">
                    <div data-aos="fade-right">
                        <span className="inline-block px-4 py-1.5 bg-gradient-to-r from-blue-800 to-blue-600 text-white text-sm font-semibold rounded-full mb-4">
                            About Us
                        </span>
                        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 mb-6">
                           Dhadak All Film Kamgar Sanghtana 
                        </h2>
                        <div className="space-y-4 text-gray-600 leading-relaxed">
                            <p className="text-sm md:text-base">
                                Dhadak All Film Kamgar Sanghtana is a prestigious professional organization dedicated to promoting excellence in art direction, costume design, and visual storytelling across the Indian film and television industry. Founded with a vision to unite creative professionals, we strive to foster innovation, professionalism, and artistic creativity in every production.
                            </p>
                            <p className="text-sm md:text-base">
                          Our association brings together some of the most talented art directors, production designers, costume designers, and creative professionals who have contributed to shaping the iconic visuals of Indian cinema and television.

                            </p>
                            <p className="text-sm md:text-base">
                           We are committed to supporting our members through networking opportunities, skill development programs, industry insights, and platforms to showcase their exceptional work. Through workshops, seminars, and collaborative projects, we continuously work to elevate the standards of art direction, design, and visual storytelling in the industry.

                           </p>
                        </div>

 




                        {/* <div className="mt-8">
                            <Link 
                                to={HISTORY_ROUTE}
                                className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-blue-800 to-blue-600 text-white font-semibold rounded-lg hover:shadow-lg transform hover:scale-105 transition-all duration-300"
                            >
                                Learn More About Us
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                                </svg>
                            </Link>
                        </div> */}
                    </div>

                    <div className="relative" data-aos="fade-left">
                        <div className="relative rounded-2xl overflow-hidden shadow-xl">
                            <img
                                src="https://images.unsplash.com/photo-1485846234645-a62644f84728?w=800"
                                alt="Film production"
                                className="w-full h-full object-cover"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
                        </div>
                        <div className="absolute -bottom-6 -left-6 bg-white rounded-xl shadow-lg p-6 max-w-xs" data-aos="zoom-in" data-aos-delay="300">
                            <p className="text-2xl md:text-3xl font-bold text-gray-900 mb-1">30+ Years</p>
                            <p className="text-gray-600 text-sm">of Creative Excellence in Indian Cinema</p>
                        </div>
                    </div>
                </div>

              
{
    milestones.length > 0 ?  
                <div data-aos="fade-up">
                    <div className="text-center mb-12">
                        <span className="inline-block px-4 py-1.5 bg-gradient-to-r from-purple-500 to-pink-500 text-white text-sm font-semibold rounded-full mb-4">
                            Our Journey
                        </span>
                        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
                            Milestones & History
                        </h2>
                        <p className="text-gray-600 text-sm md:text-base max-w-2xl mx-auto">
                            A journey of passion, dedication, and excellence spanning over three decades
                        </p>
                    </div>

                    <div className="relative">
                        {/* Timeline Line */}
                        <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 w-0.5 h-full bg-gradient-to-b from-blue-800 to-blue-600" />

                        <div className="space-y-8 md:space-y-12">
                            {milestones.map((milestone, index) => (
                                <div
                                    key={index}
                                    data-aos="fade-up"
                                    data-aos-delay={index * 100}
                                    className={`relative flex flex-col md:flex-row ${
                                        index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                                    } items-center gap-6`}
                                >
                                    {/* Content Card */}
                                    <div className="w-full md:w-5/12">
                                        <div className={`bg-white rounded-xl shadow-lg p-6 border-2 border-gray-100 hover:border-red-200 transition-all duration-300 ${
                                            index % 2 === 0 ? 'md:text-right' : 'md:text-left'
                                        }`}>
                                            <span className="inline-block px-3 py-1 bg-gradient-to-r from-blue-800 to-blue-600 text-white text-xs font-bold rounded-full mb-3">
                                                {milestone?.link}
                                            </span>
                                            <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-2">
                                                {milestone?.title}
                                            </h3>
                                            <p className="text-gray-600 text-sm md:text-base">
                                                {milestone?.description}
                                            </p>
                                        </div>
                                    </div>

                                    {/* Center Dot */}
                                    <div className="hidden md:flex w-2/12 justify-center">
                                        <div className="w-4 h-4 bg-gradient-to-br from-blue-800 to-blue-600 rounded-full ring-4 ring-white shadow-lg" />
                                    </div>

                                    {/* Empty Space */}
                                    <div className="hidden md:block w-5/12" />
                                </div>
                            ))}
                        </div>
                    </div>
                </div> 
                : ''
}

                {/* Mission & Vision */}
                {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-16 md:mt-20">
                    <div data-aos="fade-right" className="bg-gradient-to-br from-red-50 to-orange-50 rounded-2xl p-6 md:p-8 border border-red-100">
                        <div className="w-12 h-12 md:w-14 md:h-14 bg-gradient-to-br from-red-500 to-orange-500 rounded-lg flex items-center justify-center text-white mb-4">
                            <svg className="w-6 h-6 md:w-7 md:h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                            </svg>
                        </div>
                        <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3">Our Mission</h3>
                        <p className="text-gray-700 text-sm md:text-base leading-relaxed">
                            To promote and protect the interests of art directors and costume designers, foster professional excellence, provide industry-leading resources, and create opportunities for collaboration and growth in the Indian film and television industry.
                        </p>
                    </div>

                    <div data-aos="fade-left" className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-2xl p-6 md:p-8 border border-blue-100">
                        <div className="w-12 h-12 md:w-14 md:h-14 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-lg flex items-center justify-center text-white mb-4">
                            <svg className="w-6 h-6 md:w-7 md:h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                            </svg>
                        </div>
                        <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3">Our Vision</h3>
                        <p className="text-gray-700 text-sm md:text-base leading-relaxed">
                            To be the leading association representing art directors and costume designers, setting industry standards, nurturing talent, and contributing to the global recognition of Indian cinema's visual excellence.
                        </p>
                    </div>
                </div> */}
            </div>
        </section>
    );
}

export default HistoryAboutSection;